import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { GenericValue } from '../../../core/model/generic-value';
import { CommunicationLogUiText } from '../../communicationlog-uitexts';
import { CommunicationLogEntry } from '../../model/communication-log-entry.model';



@Component( {
    selector: 'his-communication-log-entries',
    templateUrl: './communication-log-entries.component.html',
    styleUrl: './communication-log-entries.component.css',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
} )
export class CommunicationLogEntriesComponent implements OnInit, OnChanges {
    @Input( { required: true } ) logEntries: CommunicationLogEntry[];
    @Input( { required: true } ) availableDomains: GenericValue[];
    @Input( { required: true } ) ownerId: number;
    @Input( { required: true } ) isDataComplete: boolean;

    @Output() deleteEntry: EventEmitter<number> = new EventEmitter<number>();
    @Output() editEntry: EventEmitter<number> = new EventEmitter<number>();
    @Output() requestMoreEntries: EventEmitter<void> = new EventEmitter<void>();

    @ViewChild( 'logContainer' ) logContainer: ElementRef;

    protected uiText = CommunicationLogUiText;
    protected domainsById = new Map<number, GenericValue>();

    constructor() { }

    protected entryId(index: number, entry: CommunicationLogEntry): number {
        return entry.id;
    }

    ngOnInit(): void {
        this.updateDomainCache();
    }

    ngOnChanges( changes: SimpleChanges ): void {
        if ( changes.availableDomains ) {
            this.updateDomainCache();
        }
    }

    private updateDomainCache() {
        this.domainsById = new Map( this.availableDomains.map( domain => [domain.id, domain] ) );
    }

    protected deleteEntryById( id: number ): void {
        this.deleteEntry.emit( id );
    }

    protected editEntryById( id: number ): void {
        this.editEntry.emit( id );
    }

    public scrollToLatestEntry(): void {
        this.logContainer.nativeElement.scrollTop = 0;
    }
}
